/* Tribe & Trowel — Cart widgets v2 (AOV Stack Phases 2-3, redesigned 2026-07-19)
   Two mounts per cart container: a slim free-shipping bar on top, and an
   "Complete your garden" upsell module BELOW the line items — featured
   digital-library card + compact companion grid. Config from window.TT_CARTW
   (emitted by snippets/tt-tokens.liquid). */
(function () {
  var CFG = window.TT_CARTW || {};
  var THRESHOLD = CFG.thresholdCents || 5000;
  var SHIP_COST = CFG.shipCostCents || 1000;
  var COMPANIONS = CFG.companions || {};
  var FEATURED = CFG.featured || null;
  var state = { total: 0, productIds: [], busy: false, earned: null, justEarned: false };

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }

  /* ---------- cart state ---------- */
  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      state.total = cart.total_price;
      state.productIds = cart.items.map(function (i) { return String(i.product_id); });
      /* fire the unlock celebration only on the crossing, not on every render */
      var earned = state.total >= THRESHOLD;
      if (state.earned === false && earned) {
        state.justEarned = true;
        setTimeout(function () { state.justEarned = false; renderAll(); }, 1600);
      }
      state.earned = earned;
      renderAll();
    }).catch(function () {});
  }

  /* ---------- html ---------- */
  var ICON_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 4h13v10H1z"/><path d="M14 8h4l3 3v3h-7z"/><circle cx="5.5" cy="17" r="2"/><circle cx="17.5" cy="17" r="2"/></svg>';
  var ICON_LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>';
  var ICON_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5l5.5 5.5L20 6.5"/></svg>';
  var ICON_SPROUT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21v-8"/><path d="M12 13C12 9 9 6 5 6c0 4 3 7 7 7z"/><path d="M12 13c0-3.5 2.6-6 6-6 0 3.5-2.6 6-6 6z"/></svg>';

  function barHtml() {
    var remaining = Math.max(0, THRESHOLD - state.total);
    var pct = Math.min(100, Math.round(state.total * 100 / THRESHOLD));
    var earned = remaining === 0;
    var cls = 'ttcw-bar' + (earned ? ' is-earned' : '') + (state.justEarned ? ' is-pop' : '');

    return '<div class="' + cls + '">' +
      '<div class="ttcw-head">' +
        '<span class="ttcw-icon">' + (earned ? ICON_CHECK : ICON_TRUCK) + '</span>' +
        '<p class="ttcw-msg" aria-live="polite" role="status">' + (earned
          ? 'Free shipping <span class="ttcw-unlocked">unlocked</span>'
          : 'Add <b>' + money(remaining) + '</b> to unlock <b>free shipping</b>') + '</p>' +
        '<span class="ttcw-save">' + (earned
          ? 'You saved ' + money(SHIP_COST)
          : '<s>' + money(SHIP_COST) + '</s> shipping') + '</span>' +
      '</div>' +
      '<div class="ttcw-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Progress toward free shipping">' +
        '<span class="ttcw-fill" style="width:' + pct + '%"><i class="ttcw-shine"></i></span>' +
        /* rider hides at the extremes: at 0 it hangs off the track, at 100 it
           would collide with the goal marker (which is the payoff to look at) */
        (pct > 3 && !earned
          ? '<span class="ttcw-rider" style="left:' + Math.min(93, pct) + '%">' + ICON_SPROUT + '</span>'
          : '') +
        '<span class="ttcw-goal">' + (earned ? ICON_CHECK : ICON_LOCK) + '</span>' +
      '</div>' +
      '<div class="ttcw-scale"><span>' + money(state.total) + '</span><span class="ttcw-goal-label">' + money(THRESHOLD) + ' &middot; free shipping</span></div>' +
      '</div>';
  }

  function xsellHtml() {
    if (!state.productIds.length) return '';
    var html = '';
    var showFeatured = FEATURED && state.productIds.indexOf(String(FEATURED.id)) === -1;
    var picks = companionPicks();
    if (!showFeatured && !picks.length) return '';

    html += '<div class="ttcw-xhead-row"><span class="ttcw-rule"></span><h3 class="ttcw-xhead">Complete your <em>garden</em></h3><span class="ttcw-rule"></span></div>';

    if (showFeatured) {
      html += '<div class="ttcw-feat">' +
        '<img src="' + FEATURED.image + '" alt="" width="72" height="72" loading="lazy">' +
        '<div class="ttcw-feat-body">' +
          '<span class="ttcw-feat-chip">' + FEATURED.chip + '</span>' +
          '<a class="ttcw-feat-title" href="' + FEATURED.url + '">' + FEATURED.title + '</a>' +
          '<span class="ttcw-feat-tag">' + FEATURED.tagline + '</span>' +
        '</div>' +
        '<div class="ttcw-feat-cta"><b>' + money(FEATURED.price) + '</b>' +
          '<button type="button" class="ttcw-add" data-ttcw-add="' + FEATURED.variantId + '" aria-label="Add ' + FEATURED.title + ' to cart">Add</button>' +
        '</div></div>';
    }

    if (picks.length) {
      html += '<div class="ttcw-grid">';
      picks.forEach(function (c) {
        html += '<div class="ttcw-mini">' +
          '<img src="' + c.image + '" alt="" width="44" height="44" loading="lazy">' +
          '<span class="ttcw-mini-info"><a href="' + c.url + '">' + c.title + '</a><b>' + money(c.price) + '</b></span>' +
          '<button type="button" class="ttcw-add ttcw-add--ghost" data-ttcw-add="' + c.variantId + '" aria-label="Add ' + c.title.replace(/"/g, '') + ' to cart">+</button>' +
          '</div>';
      });
      html += '</div>';
    }
    return html;
  }

  function companionPicks() {
    var seen = {}, picks = [];
    state.productIds.forEach(function (pid) {
      (COMPANIONS[pid] || []).forEach(function (c) {
        var cid = String(c.id);
        if (seen[cid] || state.productIds.indexOf(cid) !== -1 || !c.available) return;
        if (FEATURED && cid === String(FEATURED.id)) return;
        seen[cid] = true;
        picks.push(c);
      });
    });
    return picks.slice(0, 2);
  }

  /* ---------- mounting ----------
     Drawer (Horizon): bar goes INSIDE .cart-drawer__inner right after the
     header; upsell goes inside the scroll content BEFORE .cart-drawer__summary
     so it sits between the line items and the totals/checkout — never below
     the payment buttons. Cart page: bar tops the form, upsell ends it. */
  var DRAWER_SELECTORS = [
    'cart-drawer-component', 'cart-drawer', '#CartDrawer', '.cart-drawer',
    '[data-cart-drawer]', 'dialog[id*="cart" i]', '[id*="CartDrawer"]'
  ];
  function mountSpecs() {
    var specs = [];
    var drawer = null;
    for (var i = 0; i < DRAWER_SELECTORS.length; i++) {
      drawer = document.querySelector(DRAWER_SELECTORS[i]);
      if (drawer) break;
    }
    if (drawer) {
      var inner = drawer.querySelector('.cart-drawer__inner') || drawer;
      var header = inner.querySelector('.theme-drawer__header');
      var content = drawer.querySelector('.cart-drawer__content');
      var summary = drawer.querySelector('.cart-drawer__summary');
      specs.push({ root: drawer, host: inner, before: header ? header.nextElementSibling : inner.firstElementChild, cls: 'ttcw-top', drawer: true });
      if (content) specs.push({ root: drawer, host: content, before: summary, cls: 'ttcw-x', drawer: true });
      else specs.push({ root: drawer, host: inner, before: null, cls: 'ttcw-x', drawer: true });
    }
    var cartForm = document.querySelector('form[action*="/cart"]');
    if (cartForm && window.location.pathname.indexOf('/cart') === 0) {
      specs.push({ root: cartForm, host: cartForm, before: cartForm.firstElementChild, cls: 'ttcw-top', drawer: false });
      specs.push({ root: cartForm, host: cartForm, before: null, cls: 'ttcw-x', drawer: false });
    }
    return specs;
  }
  function ensure(spec) {
    var w = spec.root.querySelector('.' + spec.cls);
    if (!w) {
      w = document.createElement('div');
      w.className = spec.cls + ' tt' + (spec.drawer ? ' ttcw--drawer' : '');
      if (spec.before && spec.before.parentNode === spec.host) spec.host.insertBefore(w, spec.before);
      else spec.host.appendChild(w);
    }
    return w;
  }
  var rendering = false;
  function renderAll() {
    rendering = true; /* guard: our own DOM writes must not re-trigger the observer */
    var bar = barHtml(), x = xsellHtml();
    mountSpecs().forEach(function (spec) {
      var w = ensure(spec);
      var html = spec.cls === 'ttcw-top' ? bar : x;
      if (w.__ttHtml !== html) { w.innerHTML = html; w.__ttHtml = html; }
    });
    setTimeout(function () { rendering = false; }, 0);
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ttcw-add]');
    if (!btn || state.busy) return;
    state.busy = true;
    btn.setAttribute('disabled', '');
    fetch((CFG.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-ttcw-add'), 10), quantity: 1 }] })
    }).then(function () {
      state.busy = false;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (window.location.pathname.indexOf('/cart') === 0) { window.location.reload(); return; }
      refreshCart();
    }).catch(function () { state.busy = false; btn.removeAttribute('disabled'); });
  });

  /* live updates: intercept cart mutations */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(refreshCart, 150); });
    }
    return p;
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      this.addEventListener('load', function () { setTimeout(refreshCart, 150); });
    }
    return _open.apply(this, arguments);
  };

  /* catch late-rendered carts — only when a host lacks our widgets */
  var mo = new MutationObserver(function () {
    if (rendering) return;
    var specs = mountSpecs();
    for (var i = 0; i < specs.length; i++) {
      if (!specs[i].root.querySelector('.' + specs[i].cls)) { renderAll(); return; }
    }
  });

  function boot() {
    refreshCart();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
